/**
 * Cognito Action enum.
 * @enum { string }
 */
export enum CognitoAction {
  EnterCode = 'EnterCode',
  SetNewPassword = 'SetNewPassword',
  ResetPassword = 'ResetPassword',
}
